import { HttpParams } from '@angular/common/http';

export const buildHttpParamsFromQueryParams = <T>(
  queryParams?: T
): HttpParams | undefined => {
  if (!queryParams) {
    return;
  }

  let params = new HttpParams();
  const entries = Object.entries(queryParams);

  if (entries.length === 0) {
    return params;
  }

  entries.forEach(([key, value]) => {
    if (value) {
      params = params.set(key, value as string | number | boolean);
    }
  });

  return params;
};
